import $ from 'jquery';
import {wait, nextFrame, hide, show} from "../Libraries/Utils";

$('.jsz').on('click', 'a[href^="#jsz-profile-"]', ev => {
    ev.preventDefault();
    const $link = $(ev.currentTarget);
    const $root = $link.closest('.jsz');
    const $target = $($link.attr('href'));

    $root.find('.jsz__profile-image-wrap').removeClass('active');
    $link.closest('.jsz__profile-image-wrap').addClass('active');

    (async () => {
        const $others = $root.find('.jsz__person-info')
            .filter((i, elem) => !$(elem).is($target));

        hide($others);
        await wait(300);
        $others.addClass('d-none');

        $target.removeClass('d-none');
        hide($target);
        await nextFrame();
        await nextFrame();
        show($target);
    })();

    (async () => {
        const $textImageRoot = $root.closest('.text-image').first();
        if ($textImageRoot.length === 0) {
            return;
        }

        let $imageWrap = $textImageRoot.children('.text-image__image-wrap').first();
        if ($imageWrap.length === 0) {
            $imageWrap = $('<div>', {class: 'text-image__image-wrap'});
            $textImageRoot.prepend($imageWrap);
        }

        hide($imageWrap);
        await wait(300);

        const textImageWrapHtml = $target.attr('data-text-image-content').trim();
        if (textImageWrapHtml) {
            const $newItem = $(textImageWrapHtml);
            hide($newItem);
            $imageWrap.replaceWith($newItem);
            await nextFrame();
            await nextFrame();
            show($newItem);
        } else {
            $imageWrap.remove();
        }
    })();
});

